import { useMemo } from "react";
import { CustomFieldGroup } from "../../entities/customFieldGroup";
import { useGetMyCustomFieldsQuery } from "./customFieldEndpoints";

export function useMyCustomFields() {
  const customFieldsQuery = useGetMyCustomFieldsQuery();
  const { data } = customFieldsQuery;

  const groups = useMemo(() => CustomFieldGroup.fromList(data ?? []), [data]);

  return { ...customFieldsQuery, groups };
}
